import { render, staticRenderFns } from "./SidebarBox.vue?vue&type=template&id=66df9f83&"
import script from "./SidebarBox.vue?vue&type=script&lang=js&"
export * from "./SidebarBox.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports